/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerRemoveMutationResponse, TemplateQuestionPromptsControllerRemovePathParams, TemplateQuestionPromptsControllerRemove401, TemplateQuestionPromptsControllerRemove403, TemplateQuestionPromptsControllerRemove404 } from "../../models/checklistsController/TemplateQuestionPromptsControllerRemove";

function getTemplateQuestionPromptsControllerRemoveUrl(id: TemplateQuestionPromptsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-question-prompts/${id}` as const }  
  return res
}

/**
 * @summary Delete a checklist template question prompt (soft delete)
 * {@link /api/v1/checklist-template-question-prompts/:id}
 */
export async function templateQuestionPromptsControllerRemove(id: TemplateQuestionPromptsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionPromptsControllerRemoveMutationResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerRemove401 | TemplateQuestionPromptsControllerRemove403 | TemplateQuestionPromptsControllerRemove404>, unknown>({ method : "DELETE", url : getTemplateQuestionPromptsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}